import React from 'react';
import { Table } from '@tanstack/react-table';
import { MembershipDto } from '@area-restrita/api-client/model/membershipDto';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import DataGrid from '@/components/DataGrid';
// import { Input } from '@/components/ui/input';

import InviteDialog from '../../components/InviteDialog';
import DataTableToolbar from '@/components/DataTable/DataTableToolbar';

interface IProps {
  table: Table<MembershipDto>;
  isLoading: boolean;

  canInvite: boolean;
}

const MembersSettingsView: React.FC<IProps> = ({
  table,
  isLoading,
  canInvite,
}) => (
  <div className="grid gap-6">
    <Card>
      <CardHeader>
        <CardTitle>Membros</CardTitle>
        <CardDescription>
          Gerencie os membros que possuem acesso.
        </CardDescription>
      </CardHeader>

      <CardContent className="p-0">
        <DataGrid
          table={table}
          isLoading={isLoading}
          actions={
            canInvite && (
              <InviteDialog>
                <Button size="sm" className="h-8">
                  Convidar membro
                </Button>
              </InviteDialog>
            )
          }
          toolbar={
            <DataTableToolbar
              table={table}
              searchPlaceholder="Buscar membro..."
              searchColumnId="searchTerm"
            />
          }
        />
      </CardContent>
    </Card>
  </div>
);

export default MembersSettingsView;
